import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// project imports
import { getTokenLocal, getUserLocal } from 'utils/localStorage.util';

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required.
 * If user is already logged in, redirect them away from login/auth pages to their dashboard.
 * @param {PropTypes.node} children children element/node
 */
const GuestGuard = ({ children }) => {
    const token = getTokenLocal();
    const user = getUserLocal();

    if (token && user) {
        const redirectPath = user?.Type === 'Admin' ? '/dashboard' : '/inchargeDashboard';
        return <Navigate to={redirectPath} replace />;
    }

    return children;
};

GuestGuard.propTypes = {
    children: PropTypes.node
};

export default GuestGuard;
